export class UserRightsRoleToUserRightsFunctionDTO {

  //region FIELDS
  userRightsRoleId: string;
  userRightsFunctionIds: string[] = [];
  //endregion

}
